<template>
  <div class="articlePage">
    <div class="up">
      <div class="count">
        <span>含“{{ searchWord }}”的搜索结果为 {{ totlePage }} 条</span>
      </div>
    </div>
    <br />
    <div class="content">
      <V-ArticleList :newarticlelist="newarticlelist"></V-ArticleList>
    </div>
    <div v-if="newarticlelist.length == 0" style="font-size: 20px;margin-top:100px; color:#626262">抱歉未找到相关结果</div>
    <br />
    <div class="page-nav">
      <el-pagination background layout="prev, pager, next"  :total="totlePage" :page-size="pageSize"  @current-change="currentPage"></el-pagination>
    </div>
  </div>
</template>

<script>
import ArticleList from "@/components/one-article/type-one/index.vue";
import { getArctilce } from "@/services/";

export default {
  data() {
    return {
      searchWord: "",
      hotWords: [],
      pageNum: 1,
      pageSize: 10,
      totlePage: 0,
      orderActive: 1,
      newarticlelist: [],
    };
  },
  created: function () {
    this.searchWord = this.$route.query.searchWord||''
    this.searchInfo();
  },
  methods: {
    //当前页
    currentPage(e,val) {
      this.pageNum = e;
      this.searchInfo(val);
    },

    searchInfo(val) {
      let data = { type: 1, pageIndex:this.pageNum, pageSize:  this.pageSize }
      if(this.searchWord){
        data.title = this.searchWord
      }
      if(val){
        this.searchWord = val;
        data.title = val;
      }
      this.newarticlelist = [];
      getArctilce(data).then(res => {
        if (res.success) {
          let list = res.data.records
          this.totlePage = res.data.total || 0
          this.newarticlelist = list;
        } else {
          this.message({
            message: res.message,
            type: 'warning'
          })
        }
      })
    }
  },
  components: {
    "V-ArticleList": ArticleList
  }
};
</script>

<style  scoped>
@import "~@/styles/page/index.css";

/* 文章显示内容 */
.articlePage .up {
  margin-bottom: 15px;
  text-align: right;
  font-size: 10px;
}

.search-container>.main>div>div {
  display: inline-block;
  width: 800px;
}

.articlePage>.up>div {
  display: inline-block;
  width: 50%;
}

.articlePage>.up>.order {
  text-align: left;
}

.articlePage>.up>.order>.time {
  margin-left: 50px;
  margin-right: 20px;
  cursor: pointer;
}

.articlePage>.up>.order>.relate {
  margin-left: 20px;
  cursor: pointer;
}

.articlePage>.up>.order>.active {
  color: #fd6e05;
}

.articlePage>.up>.count {
  text-align: right;
}
</style>